import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        justify-content: ", ";\n        align-items: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import styled, { css } from 'styled-components';
import React, { useMemo } from 'react';
import { GroupContext } from './GroupContext';

function align(_ref) {
  var align = _ref.align,
      alignItems = _ref.alignItems;
  var justifyContent = 'flex-start';
  var alignItemsValue = 'stretch';

  switch (align) {
    case 'left':
      {
        justifyContent = 'flex-start';
        break;
      }

    case 'right':
      {
        justifyContent = 'flex-end';
        break;
      }

    case 'center':
      {
        justifyContent = 'center';
        break;
      }

    case 'spaced':
      {
        justifyContent = 'space-between';
        break;
      }
  }

  switch (alignItems) {
    case 'baseline':
      {
        alignItemsValue = 'baseline';
        break;
      }

    case 'stretch':
      {
        alignItemsValue = 'stretch';
        break;
      }

    case 'center':
      {
        alignItemsValue = 'center';
        break;
      }

    case 'end':
      {
        alignItemsValue = 'flex-end';
        break;
      }
  }

  return css(_templateObject(), justifyContent, alignItemsValue);
}

var RowContainer = styled.div(_templateObject2(), align);
export var Container = function Container(_a) {
  var _a$gap = _a.gap,
      gap = _a$gap === void 0 ? 0 : _a$gap,
      itemWidth = _a.itemWidth,
      _a$align = _a.align,
      align = _a$align === void 0 ? 'left' : _a$align,
      _a$alignItems = _a.alignItems,
      alignItems = _a$alignItems === void 0 ? 'stretch' : _a$alignItems,
      children = _a.children,
      props = __rest(_a, ["gap", "itemWidth", "align", "alignItems", "children"]);

  var contextValue = useMemo(function () {
    return {
      gap: gap,
      itemWidth: itemWidth
    };
  }, [gap, itemWidth]);
  return React.createElement(GroupContext.Provider, {
    value: contextValue
  }, React.createElement(RowContainer, Object.assign({}, props, {
    align: align,
    alignItems: alignItems
  }), children));
};
Container.displayName = 'Container';